import { useSelector } from 'react-redux';
import { RootState } from '../store';

/**
 * useAuth Hook
 * Provides access to authentication state
 */
export const useAuth = () => {
    const { user, token, isAuthenticated } = useSelector(
        (state: RootState) => state.auth
    );

    return {
        user,
        token,
        isAuthenticated,
    };
};
